export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["all"] = "all";
    AccessLevel["only"] = "only";
})(AccessLevel || (AccessLevel = {}));
export var DocumentTeleconsentType;
(function (DocumentTeleconsentType) {
    DocumentTeleconsentType["teleconsent"] = "teleconsent";
    DocumentTeleconsentType["default"] = "teleconsent-default";
})(DocumentTeleconsentType || (DocumentTeleconsentType = {}));
